/* ============================================================
   Advanced Look Finder — JS
   Strategia filtro (data-strategy sulla sezione):
     - "tag"      (default, sempre funzionante): token TAG (prefisso + valore,
                  es. colore-rosa) => filter.p.tag su collection, oppure token
                  nel testo q su /search. Non richiede metafield/Search&Discovery.
     - "metafield": filtri nativi Shopify (filter.p.m.namespace.key). Usa SOLO
                  quando i metafield sono configurati + Search & Discovery attivo.
     - "both"     : tag + metafield insieme (AND). Solo se i prodotti hanno sia
                  tag che metafield popolati, altrimenti restringe troppo.
   Funziona anche con un solo campo. Nessuna libreria. prefers-reduced-motion.
   ============================================================ */
(function () {
  "use strict";
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function initForm(form) {
    var section = form.closest(".scm-finder");
    if (!section) return;
    var targetCollection = section.getAttribute("data-target");
    var searchPath = section.getAttribute("data-search-path") || "/search";
    var strategy = (section.getAttribute("data-strategy") || "tag").toLowerCase();
    var useTag = strategy === "tag" || strategy === "both";
    var useMeta = strategy === "metafield" || strategy === "both";

    // particelle decorative
    var sparkWrap = section.querySelector(".scm-finder__sparkles");
    if (sparkWrap && !reduce && !sparkWrap.childElementCount) {
      for (var i = 0; i < 22; i++) {
        var sp = document.createElement("span");
        sp.className = "scm-sp";
        var size = (Math.random() * 4 + 2).toFixed(1);
        sp.style.width = sp.style.height = size + "px";
        sp.style.left = (Math.random() * 100).toFixed(1) + "%";
        sp.style.top = (Math.random() * 100).toFixed(1) + "%";
        sp.style.animationDelay = (Math.random() * 4).toFixed(1) + "s";
        sp.style.animationDuration = (Math.random() * 3 + 3).toFixed(1) + "s";
        sparkWrap.appendChild(sp);
      }
    }

    form.addEventListener("submit", function (e) {
      e.preventDefault();

      var q = "";
      var qInput = form.querySelector('input[name="q"]');
      if (qInput) q = qInput.value.trim();

      // Raccogli i filtri selezionati (ignora i vuoti)
      var filters = [];
      form.querySelectorAll("select").forEach(function (sel) {
        if (!sel.value) return;
        filters.push({
          filterKey: sel.getAttribute("data-filter-key") || sel.name || "",
          metafield: (sel.getAttribute("data-metafield") || "").trim(),
          tagPrefix: (sel.getAttribute("data-tag-prefix") || "").trim(),
          value: sel.value
        });
      });

      // Token tag (prefisso + valore, es. colore-rosa). Se il campo non ha
      // prefisso tag, ricade sul valore semplice.
      var tagTokens = useTag ? filters.map(function (f) {
        return f.tagPrefix ? f.tagPrefix + f.value : f.value;
      }).filter(Boolean) : [];

      // Filtri metafield nativi (solo se mappati)
      var metaParams = useMeta ? filters.filter(function (f) {
        return f.metafield && f.filterKey;
      }) : [];

      // Se la strategia metafield non ha prodotto nessun parametro nativo ma
      // esistono filtri selezionati, ricade comunque sui tag per non perdere la
      // selezione dell'utente.
      if (useMeta && !useTag && metaParams.length === 0 && filters.length > 0) {
        tagTokens = filters.map(function (f) {
          return f.tagPrefix ? f.tagPrefix + f.value : f.value;
        }).filter(Boolean);
      }

      // Flag attivi (es. "Solo nuova collezione"): aggiungono un tag e/o un
      // filtro metafield nativo quando spuntati.
      form.querySelectorAll(".scm-finder__flag-input").forEach(function (cb) {
        if (!cb.checked) return;
        var ftag = (cb.getAttribute("data-flag-tag") || "").trim();
        var fkey = (cb.getAttribute("data-flag-key") || "").trim();
        var fval = (cb.getAttribute("data-flag-value") || "").trim();
        if (useTag && ftag) tagTokens.push(ftag);
        if (useMeta && fkey) metaParams.push({ filterKey: fkey, value: fval });
        if (useMeta && !useTag && !fkey && ftag) tagTokens.push(ftag);
      });

      var hasSelection = (q !== "") || tagTokens.length > 0 || metaParams.length > 0;
      if (!hasSelection) {
        // Nessun campo selezionato: vai alla destinazione base senza filtri.
        window.location.href = targetCollection ? "/collections/" + targetCollection : searchPath;
        return;
      }

      var params = new URLSearchParams();

      if (targetCollection) {
        // Pagina collezione: tag e/o metafield nativi.
        if (q) params.set("q", q);
        tagTokens.forEach(function (tok) { params.append("filter.p.tag", tok); });
        metaParams.forEach(function (f) { params.append(f.filterKey, f.value); });
        var url = "/collections/" + targetCollection;
        var qs = params.toString();
        window.location.href = qs ? url + "?" + qs : url;
      } else {
        // Ricerca: token tag dentro q (garantisce risultati anche senza metafield)
        var qparts = [];
        if (q) qparts.push(q);
        qparts = qparts.concat(tagTokens);
        params.set("q", qparts.join(" ").trim() || "*");
        params.set("type", "product");
        // Aggiunge anche i filtri metafield nativi (utili con Search & Discovery)
        metaParams.forEach(function (f) { params.append(f.filterKey, f.value); });
        window.location.href = searchPath + "?" + params.toString();
      }
    });
  }

  function boot() {
    document.querySelectorAll('[id^="scm-finder-form-"]').forEach(initForm);
  }
  if (document.readyState !== "loading") boot();
  else document.addEventListener("DOMContentLoaded", boot);
  document.addEventListener("shopify:section:load", boot);
})();
